import { render, staticRenderFns } from "./unpayBatchInfo.vue?vue&type=template&id=70ee9471&scoped=true&"
import script from "./unpayBatchInfo.vue?vue&type=script&lang=js&"
export * from "./unpayBatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./unpayBatchInfo.vue?vue&type=style&index=0&id=70ee9471&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee9471",
  null
  
)

export default component.exports